module.exports = __webpack_public_path__ + "static/media/all.650ac83a.pred";